(ns app.front.view.complaint.util
  (:require [app.domain.complaint.model :as complaint-model]
            [core.util.schemas :as schemas]
            [schema-tools.core :as st]
            [schema.core :as s]))

(def category-base-style
  (str "border-solid border-ui-violet-100 rounded px-3 py-1 min-h-8 flex items-center "
       "justify-between uppercase font-semibold focus:outline-none text-sm overflow-hidden "
       "focus:box-shadow-none"))

(def category-unselected-style "bg-white text-ui-violet-100")

(def category-selected-style "bg-ui-black text-ui-white")

(def form-validation-schema
  (-> complaint-model/Complaint
      (assoc :complaint/complainer-email schemas/UserInputEmail)))

(defn valid? [field-name value]
  (nil? (when-let [schema-field (st/get-in form-validation-schema [field-name])]
          (s/check schema-field value))))

(defn can-edit-complaint? [complaint]
  (and (complaint-model/editable? complaint)
       (contains? (:granted-permissions complaint) :permission.workspace/write)))
